import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { images } from "../../assets";
import { useLanguage } from "../../contexts/LanguageContext";

const MobileCompleted = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const isError = location?.state?.isError;

  return (
    <Box sx={{ bgcolor: '#f5f5f7', minHeight: '100vh' }}>
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      <Container>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={3}
          sx={{ height: "60vh" }}
        >
          <img
            src={isError ? images.certageError : images.certageCheckmar}
            alt={isError ? "Error" : "Success"}
            style={{
              width: "min(50vw, 200px)",
              height: "auto",
            }}
          />
          <Typography
            textAlign="center"
            variant="h4"
            fontWeight={700}
            color="#3F4145"
          >
            {isError ? t.mobileCompleted.errorTitle : t.mobileCompleted.title}
          </Typography>
          <Typography
            textAlign="center"
            variant="h6"
            color="#777"
            sx={{ maxWidth: 400 }}
          >
            {isError ? t.mobileCompleted.errorMessage : t.mobileCompleted.message}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default MobileCompleted;
